// ✅ React + Router
import React, { Component } from 'react';
import withRouter from '../withRouter';

// ✅ Axios (HTTP client)
import axios from 'axios';

// ✅ React-Bootstrap components
import { Row, Col, Card, Image } from 'react-bootstrap';

// ✅ RSuite components
import {
    Panel,
    Input,
    ButtonToolbar,
    Button,
    Text,
    Checkbox,
    Table,
    Pagination,
    Modal,
    Loader
} from 'rsuite';

// SweetAlert2 for alerts
import Swal from 'sweetalert2';

class DetailPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modal: null,
            year: null,
            comment: '',
            sortColumn: null,
            sortType: null,
            loading: false,
            limit: 25,
            page: 1,
            data: [],
            scoringCriteriaList: []
        };
    }

    async componentDidMount() {

        await this.onRenderContent({ mode: 'read' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    formatDateOfBirth(dateOfBirth) {
        const date = new Date(dateOfBirth);

        // Thai locale options for formatting
        const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        };

        // Format the date using Thai locale
        const formattedDate = new Intl.DateTimeFormat('th-TH', options).format(date);

        // Convert the year to Buddhist Era (BE), which is 543 years ahead of the Gregorian calendar
        const buddhistYear = date.getFullYear() + 543;

        // Replace the Gregorian year with the Buddhist Era year in the formatted date
        const finalDate = formattedDate.replace(date.getFullYear(), buddhistYear);

        return finalDate;
    }

    formatBaht(income) {
        // Convert the number to a formatted string with commas and two decimal places
        return income.toLocaleString('th-TH', {
            minimumFractionDigits: 2,  // Ensures two decimal places
            maximumFractionDigits: 2   // Limits to two decimal places
        });
    }

    handleSortColumn = (sortColumn, sortType) => {
        this.setState({ sortColumn, sortType }, () => {
            this.onRenderContent({ mode: 'read' });
        });
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true });

            const { Column, HeaderCell, Cell } = Table;

            try {

                // 1️⃣ ดึงข้อมูล committee
                const { data: committeeData } = await axios.get(
                    `${process.env.REACT_APP_API}/committee/path/${this.props.params.id}`
                );

                await this.promisedSetState({
                    committee_id: committeeData.id,
                    committee_groups: committeeData.groups,
                    year: committeeData.year
                });

                const committeeName = committeeData.name;

                // ฟังก์ชันช่วยคำนวณอายุ
                function calculateAge(dob) {
                    if (!dob) return null;
                    const birthDate = new Date(dob);
                    const diff = Date.now() - birthDate.getTime();
                    const ageDate = new Date(diff);
                    return Math.abs(ageDate.getUTCFullYear() - 1970);
                }

                // ฟังก์ชันแปลงระดับการศึกษา
                function mapEducationLevel(level) {
                    if (!level) return '';
                    if (level.includes('มัธยมศึกษาปีที่')) return 'ม.' + level.match(/\d+/)?.[0];
                    if (level.includes('ปวช.')) return 'ปวช.' + level.match(/\d+/)?.[0];
                    if (level.includes('ปวส.')) return 'ปวส.' + level.match(/\d+/)?.[0];
                    return level;
                }

                // 2️⃣ ดึง applications ตามปี (เรียงจาก backend ตาม committee_order)
                const { data: applications = [] } = await axios.get(
                    `${process.env.REACT_APP_API}/application/order/${this.props.params.id}`
                );

                // 3️⃣ ดึง voting
                const { data: votingData = [] } = await axios.get(
                    `${process.env.REACT_APP_API}/voting/year/${committeeData.year}/${committeeData.id}`
                );

                // 4️⃣ สร้าง map lookup จาก application_id
                const votingMap = votingData.reduce((map, vote) => {
                    map[vote.application_id] = vote;
                    return map;
                }, {});

                // 5️⃣ แปลง applications พร้อม voteStatus และ score
                const formattedData = applications.map(app => {
                    const vote = votingMap[app.id];
                    return {
                        id: app.id,
                        prefix: app.prefix,
                        fullName: `${app.first_name} ${app.last_name}`,
                        nickName: app.nickname,
                        age: calculateAge(app.date_of_birth),
                        village: app.reg_village === 'other' ? 'อื่นๆ' : app.reg_village,
                        level: mapEducationLevel(app.edu_level),
                        nextSchool: app.next_institution,
                        status: app.app_status,
                        voteStatus: vote ? vote.status : false,
                        comment: vote ? vote.comment : null,
                        score: vote ? vote.total : null,
                        voteId: vote ? vote.id : null,
                        sort: app.sort ?? Number.MAX_SAFE_INTEGER // ใช้ sort จาก backend ถ้ามี
                    };
                });

                // 6️⃣ เรียงตาม sort จาก committee_order
                const sortedData = [...formattedData].sort((a, b) => a.sort - b.sort);

                // 7️⃣ Pagination
                const { sortColumn, sortType, page = 1, limit = 10 } = this.state;
                const paginatedData = (!sortColumn || !sortType)
                    ? sortedData.slice((page - 1) * limit, page * limit)
                    : sortedData.slice().sort((a, b) => {
                        let x = a[sortColumn];
                        let y = b[sortColumn];
                        if (typeof x === 'string') x = x.toLowerCase();
                        if (typeof y === 'string') y = y.toLowerCase();
                        if (sortType === 'asc') return x > y ? 1 : -1;
                        return x < y ? 1 : -1;
                    }).slice((page - 1) * limit, page * limit);

                const pendingCount = sortedData.filter(item => !item.voteStatus).length;

                // 8️⃣ อัปเดต state
                await this.promisedSetState({
                    data: paginatedData,
                    pendingCount,
                    committeeName
                });

                if (committeeData.vote_status === false) {

                    await this.promisedSetState({
                        content: (
                            <div style={{ padding: 20 }}>
                                <Row className="mb-3">
                                    <Col xs={24} sm={12} className="mb-2">
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                marginBottom: '20px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: '1.8rem',
                                                    fontWeight: '700',
                                                    color: '#2c3e50',
                                                    letterSpacing: '0.5px',
                                                    marginBottom: '4px'
                                                }}
                                            >
                                                การพิจารณาคัดเลือกนักเรียนทุนการศึกษา ประจำปี {committeeData.year}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: '1.6rem',
                                                    fontWeight: '700',
                                                    color: '#1976D2',
                                                    letterSpacing: '0.3px'
                                                }}
                                            >
                                                {this.state.committee_groups === '1' ? 'คณะกรรมการชุดที่ 1' : 'คณะกรรมการชุดที่ 2'}
                                            </div>

                                        </div>
                                    </Col>

                                    <Col lg={5} className='mb-3'>
                                        <Panel
                                            bordered
                                            style={{
                                                padding: '14px 20px',
                                                border: '1px solid #e5e5e5',
                                                borderRadius: '10px',
                                                backgroundColor: '#ffffff',
                                            }}
                                        >
                                            {/* หัวข้อกรรมการ */}
                                            <div
                                                className="mb-3"
                                                style={{
                                                    fontSize: '1.6rem',
                                                    fontWeight: '700',
                                                    color: '#222',
                                                    borderBottom: '2px solid #f0f0f0',
                                                    paddingBottom: '12px',
                                                    marginBottom: '24px'
                                                }}
                                            >
                                                {committeeName}{' '}
                                                <span style={{ fontWeight: '400', color: '#555' }}>
                                                    กรรมการพิจารณาลงคะแนน
                                                </span>
                                            </div>

                                            {/* สถานะ */}
                                            {pendingCount === 0 ? (
                                                <span
                                                    style={{
                                                        backgroundColor: '#e8f8ec',
                                                        color: '#2e7d32',
                                                        alignItems: 'center',
                                                        fontSize: '1.4rem',
                                                        fontWeight: '500',
                                                        padding: '10px 14px',
                                                        borderRadius: '8px',
                                                        marginBottom: '16px',
                                                    }}
                                                >
                                                    <i className="bi bi-check-circle-fill" style={{ marginRight: '8px', fontSize: '1.4rem' }}></i>
                                                    ลงคะแนนเรียบร้อยแล้ว
                                                </span>
                                            ) : (
                                                <span
                                                    style={{
                                                        backgroundColor: '#fdecea',
                                                        color: '#d32f2f',
                                                        alignItems: 'center',
                                                        fontSize: '1.4rem',
                                                        fontWeight: '500',
                                                        padding: '10px 14px',
                                                        borderRadius: '8px',
                                                        marginBottom: '16px',
                                                    }}
                                                >
                                                    <i className="bi bi-exclamation-triangle-fill" style={{ marginRight: '8px', fontSize: '1.4rem' }}></i>
                                                    ยังมีนักเรียนที่ยังไม่ลงคะแนนอีก {pendingCount} คน
                                                </span>
                                            )}
                                        </Panel>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2"><b>แสดงผล :</b></span>
                                        {[10, 25, 50, 100].map((val) => (
                                            <button
                                                key={val}
                                                className={`btn ${this.state.limit === val ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                onClick={() => this.promisedSetState({ limit: val }, this.onRenderContent({ mode }))}
                                                style={{
                                                    fontSize: '1.2rem',
                                                    padding: '4px 10px',
                                                    margin: '0 4px' // spacing ระหว่างปุ่ม
                                                    // borderRadius: '4px' // ใส่ถ้าต้องการมุมโค้งเล็ก ๆ
                                                }}
                                            >
                                                {val}
                                            </button>
                                        ))}
                                        <span className="ms-2">รายการ</span>
                                    </div>
                                </div>

                                <Table
                                    autoHeight
                                    data={paginatedData}
                                    bordered
                                    cellBordered
                                    className="shadow-sm"
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={this.handleSortColumn}
                                    style={{ borderRadius: '10px', overflow: 'hidden' }}
                                >
                                    <Column width={55} align="center" fixed>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>ลำดับที่</HeaderCell>
                                        <Cell>{(rowData, rowIndex) => <div>{(page - 1) * limit + rowIndex + 1}</div>}</Cell>
                                    </Column>

                                    <Column width={75}>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>คำนำหน้า</HeaderCell>
                                        <Cell dataKey="prefix" />
                                    </Column>

                                    <Column width={190} resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>ชื่อ-นามสกุล</HeaderCell>
                                        <Cell dataKey="fullName" />
                                    </Column>

                                    <Column width={80} resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>ชื่อเล่น</HeaderCell>
                                        <Cell dataKey="nickName" />
                                    </Column>

                                    <Column width={50} align="center" resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>อายุ</HeaderCell>
                                        <Cell align="center" dataKey="age" />
                                    </Column>

                                    <Column width={140} resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>หมู่บ้าน</HeaderCell>
                                        <Cell>
                                            {(rowData) => rowData.village === 'other' ? 'อื่นๆ' : rowData.village}
                                        </Cell>
                                    </Column>

                                    <Column width={75} resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>ระดับ</HeaderCell>
                                        <Cell dataKey="level" />
                                    </Column>

                                    <Column width={200} resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>สถานศึกษาที่จะเรียนต่อ</HeaderCell>
                                        <Cell dataKey="nextSchool" />
                                    </Column>

                                    <Column width={305} resizable>
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>สถานะ</HeaderCell>
                                        <Cell dataKey="status" />
                                    </Column>

                                    <Column width={80} align="center">
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>ลงคะแนน</HeaderCell>
                                        <Cell align="center">
                                            {(rowData) => rowData.voteStatus ? <i className="bi bi-check-lg" style={{ color: 'green' }} /> : ''}
                                        </Cell>
                                    </Column>

                                    <Column width={115} sortable align="center">
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>คะแนนรวม</HeaderCell>
                                        <Cell align="center" dataKey="score" />
                                    </Column>

                                    <Column width={130} fixed="right" align="center">
                                        <HeaderCell style={{ backgroundColor: 'rgb(138, 10, 10)', color: 'white' }} align='center'>...</HeaderCell>
                                        <Cell style={{ padding: 6 }}>
                                            {(rowData) => (
                                                <ButtonToolbar>
                                                    {rowData.voteStatus === true ? (
                                                        <Button
                                                            appearance="primary"
                                                            size="sm"
                                                            color="yellow"
                                                            startIcon={<i className="bi bi-pencil-square"></i>}
                                                            onClick={() => this.onModal({ mode: 'update', id: rowData.id, voteId: rowData.voteId, comment: rowData.comment })}
                                                        >
                                                            แก้ไข
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            appearance="primary"
                                                            size="sm"
                                                            color="blue"
                                                            startIcon={<i className="bi bi-pencil-fill"></i>}
                                                            onClick={() => this.onModal({ mode: 'insert', id: rowData.id, comment: rowData.comment })}
                                                        >
                                                            ลงคะแนน
                                                        </Button>
                                                    )}
                                                </ButtonToolbar>
                                            )}
                                        </Cell>
                                    </Column>
                                </Table>

                                <div style={{ padding: 20 }}>
                                    <Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '|', 'pager']}
                                        total={sortedData.length}
                                        limit={limit}
                                        activePage={page}
                                        onChangePage={async (e) => {
                                            await this.promisedSetState({ page: e });
                                            this.onRenderContent({ mode: 'read' });
                                        }}
                                    />
                                </div>

                                <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Col lg={5}>
                                        <Panel
                                            bordered
                                            style={{
                                                padding: '18px 24px',
                                                border: '1px solid #e5e5e5',
                                                borderRadius: '10px',
                                                backgroundColor: '#ffffff',
                                            }}
                                        >
                                            {/* ปุ่มยืนยันการลงคะแนน */}
                                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                                <Button
                                                    size="lg"
                                                    color="green"
                                                    appearance="primary"
                                                    startIcon={<i className="bi bi-check2-circle"></i>}
                                                    style={{
                                                        width: '80%',
                                                        maxWidth: '300px',
                                                        fontSize: '1.4rem',
                                                        fontWeight: '600',
                                                        borderRadius: '8px',
                                                        padding: '12px 20px'
                                                    }}
                                                    onClick={() => this.confirmVote({ status: 'close', id: this.state.committee_id })}
                                                >
                                                    ยืนยันการลงคะแนน
                                                </Button>

                                                {/* ข้อความคำเตือน */}
                                                <div
                                                    style={{
                                                        color: '#b71c1c',
                                                        marginTop: '10px',
                                                        fontWeight: '400',
                                                        fontSize: '1.4rem',
                                                    }}
                                                >
                                                    * เมื่อกดยืนยันแล้วจะไม่สามารถแก้ไขคะแนนได้อีก<br />โปรดตรวจสอบให้แน่ใจก่อนยืนยัน
                                                </div>
                                            </div>
                                        </Panel>
                                    </Col>
                                </Row>
                            </div>
                        )
                    });

                } else if (committeeData.vote_status === true) {

                    // ฟังก์ชันช่วยแปลงวันที่เป็นรูปแบบไทย
                    function formatThaiDate(dateInput) {
                        if (!dateInput) return '';

                        const d = new Date(dateInput);

                        const day = d.getDate();
                        const monthNames = [
                            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                            'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                        ];
                        const month = monthNames[d.getMonth()];
                        const year = d.getFullYear() + 543; // แปลง ค.ศ. -> พ.ศ.

                        // ดึงชั่วโมงและนาที
                        let hours = d.getHours();
                        let minutes = d.getMinutes();

                        // เติมเลขศูนย์หน้า
                        hours = hours.toString().padStart(2, '0');
                        minutes = minutes.toString().padStart(2, '0');

                        return `วันที่ ${day} ${month} ${year} เวลา ${hours}.${minutes} น.`;
                    }

                    await this.promisedSetState({
                        content: (
                            <div
                                style={{
                                    maxWidth: '550px',
                                    margin: '3rem auto',
                                    padding: '3rem',
                                    borderRadius: '12px',
                                    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
                                    textAlign: 'center',
                                    backgroundColor: '#ffffff',
                                    // responsive font scaling
                                    fontSize: '1rem',
                                }}
                            >
                                {/* Icon */}
                                <div
                                    style={{
                                        fontSize: '6rem',
                                        color: '#4CAF50',
                                        marginBottom: '0.5rem',
                                    }}
                                >
                                    <i className="bi bi-check2-circle"></i>
                                </div>

                                {/* ข้อความหลัก */}
                                <h2
                                    style={{
                                        color: '#333',
                                        fontSize: '2rem',
                                        marginBottom: '1rem',
                                        fontWeight: '600',
                                    }}
                                >
                                    การลงคะแนนเสร็จสมบูรณ์
                                </h2>

                                {/* วันที่/เวลา */}
                                <p
                                    style={{
                                        fontSize: '1.8rem',
                                        color: '#555',
                                        marginBottom: '1.8rem',
                                        lineHeight: '1.4',
                                    }}
                                >
                                    คณะกรรมการได้ทำการลงคะแนนเรียบร้อยแล้ว<br />
                                    <strong style={{ fontSize: '1.5rem', color: '#000' }}>
                                        เมื่อ{formatThaiDate(committeeData.vote_confirmed_at)}
                                    </strong>
                                </p>

                                {/* แจ้งเตือนด้านล่าง */}
                                <p
                                    style={{
                                        fontSize: '1.5rem',
                                        color: '#D32F2F',
                                        lineHeight: '1.6',
                                        marginTop: '1rem',
                                    }}
                                >
                                    หากต้องการแก้ไขคะแนน กรุณาติดต่อ <strong>Admin</strong>
                                </p>

                                {/* Media query สำหรับมือถือ */}
                                <style>
                                    {`
                    @media (max-width: 600px) {
                        div[style*="maxWidth: 550px"] {
                            padding: 2rem;
                        }
                        div[style*="fontSize: 8rem"] {
                            font-size: 5rem !important;
                        }
                        h2 {
                            font-size: 1.8rem !important;
                        }
                        p {
                            font-size: 1.2rem !important;
                        }
                        p strong {
                            font-size: 1rem !important;
                        }
                    }
                `}
                                </style>
                            </div>
                        )
                    });

                }
            } catch (error) {
                console.error('Error loading content:', error);

                // ตรวจว่าเป็น 404 หรือข้อมูลไม่เจอ
                const isNotFound = error.response?.status === 404 || error.message === "Committee not found";

                await this.promisedSetState({
                    content: (
                        <div
                            style={{
                                maxWidth: 400,
                                margin: '80px auto',
                                padding: 30,
                                textAlign: 'center',
                                color: '#555',
                            }}
                        >
                            <i
                                className="bi bi-question-square-fill"
                                style={{ fontSize: 50, color: '#007bff', marginBottom: 20 }}
                            ></i>
                            <h3 style={{ marginBottom: 8, fontWeight: '600' }}>ไม่พบข้อมูลในระบบ</h3>
                            <p style={{ fontSize: 22, lineHeight: 1.2, color: '#666' }}>
                                กรุณาตรวจสอบข้อมูลอีกครั้งหรือลองใหม่ในภายหลัง
                            </p>
                        </div>
                    ),
                    loading: false
                });

                return;
            }

            await this.promisedSetState({ loading: false });
        }
    };

    handleScoreChange = (committeeId, id, newScore, mode, voteId, comment) => {
        this.setState(prevState => {
            const updatedList = prevState.scoringCriteriaList.map(item =>
                item.committeeId === committeeId
                    ? { ...item, selectedScore: newScore }
                    : item
            );
            return { scoringCriteriaList: updatedList };
        }, () => {
            this.onModal({ mode, id, sel: true, voteId, comment });
        });
    };

    onModal = async ({ mode, id, sel = false, voteId = null, comment }) => {
        try {
            await this.promisedSetState({ loading: true });

            // 🧾 Always get applicant data
            const [{ data: applicantRaw }] = await Promise.all([
                axios.get(`${process.env.REACT_APP_API}/application/${id}`)
            ]);
            const applicantData = applicantRaw?.[0];
            if (!applicantData) throw new Error('ไม่พบข้อมูลผู้สมัคร');

            let scoringCriteriaList = [];

            // 🚫 ไม่โหลดซ้ำถ้า sel = true (เช่น กรณี handleScoreChange)
            if (!sel) {
                if (mode === 'insert') {
                    const { data: criteriaList } = await axios.get(
                        `${process.env.REACT_APP_API}/criteria/year/${this.state.year}`
                    );

                    scoringCriteriaList = criteriaList.map((item, i) => ({
                        no: i + 1,
                        applicationId: id,
                        criteria: item.details,
                        weight: item.weight ?? 0,
                        selectedScore: null,
                        committeeId: item.id,
                    }));
                }

                if (mode === 'update' && voteId) {
                    const { data: voteRaw } = await axios.get(`${process.env.REACT_APP_API}/voting/${voteId}`);
                    const vote = Array.isArray(voteRaw) ? voteRaw[0] : voteRaw;

                    // แปลงคะแนน
                    const scores = typeof vote.score === 'string'
                        ? JSON.parse(vote.score)
                        : vote.score;

                    // ดึง criteria ทั้งหมดแบบ async
                    const criteriaPromises = scores.map(item =>
                        axios.get(`${process.env.REACT_APP_API}/criteria/${item.criteria_id}`)
                            .then(({ data }) => ({
                                no: scores.indexOf(item) + 1,
                                applicationId: vote.application_id,
                                criteria: data.details,
                                weight: data.weight,
                                selectedScore: item.score,
                                committeeId: item.criteria_id
                            }))
                            .catch(() => ({
                                no: scores.indexOf(item) + 1,
                                applicationId: vote.application_id,
                                criteria: '',
                                weight: 0,
                                selectedScore: item.score,
                                committeeId: item.criteria_id
                            }))
                    );

                    scoringCriteriaList = await Promise.all(criteriaPromises);
                }
            }

            // ✅ ตั้งค่าข้อมูลทั้งหมด
            await this.promisedSetState({
                loading: false,
                applicantData,
                ...(scoringCriteriaList.length > 0 && { scoringCriteriaList })
            });

            // 👁 แสดง modal
            this.showModal(mode, voteId, comment);

        } catch (error) {
            console.error('onModal error:', error);
            this.setState({ loading: false });
        }
    };

    showModal = async (mode, voteId, comment) => {
        const { applicantData: data } = this.state;

        function calculateAge(dob) {
            const birthDate = new Date(dob);
            const diff = Date.now() - birthDate.getTime();
            const ageDate = new Date(diff);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        await this.promisedSetState({ comment: comment })

        await this.promisedSetState({
            modal: (
                <Modal
                    backdrop="static"
                    keyboard={false}
                    open={true}
                    size="full"
                    className="responsive-panel"
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title className="responsive-panel">การพิจารณาคัดเลือกนักเรียนทุนการศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ padding: '0.6em' }}>
                        <Row>
                            <Col xs={24}>
                                <Card className="mb-4" style={{
                                    borderRadius: '12px',
                                    color: '#333',
                                }}>
                                    <Card.Header style={{
                                        backgroundColor: 'rgb(138, 10, 10)',
                                        color: '#fff',
                                        borderTopLeftRadius: '12px',
                                        borderTopRightRadius: '12px',
                                        padding: '8px',
                                    }}>
                                        ข้อมูลผู้สมัครของ {data.first_name} {data.last_name}
                                    </Card.Header>
                                    <Card.Body style={{ padding: '1em' }}>
                                        {/* รูปผู้สมัคร */}
                                        <div style={{ textAlign: 'center', marginBottom: '1.5em' }}>
                                            <Image
                                                src={`${process.env.REACT_APP_UPLOAD}/${data.path}`}
                                                rounded
                                                style={{ width: '2.5cm', height: '3.5cm', borderRadius: '6px' }}
                                            />
                                        </div>

                                        {/* สิทธิ์ในการสมัคร */}
                                        <div>
                                            <div style={{ fontWeight: '700', marginBottom: '0.75em' }}>
                                                สิทธิ์ในการสมัคร:
                                            </div>
                                            <div>
                                                <Checkbox checked={data.rights4} readOnly>
                                                    บุตรพนักงาน
                                                </Checkbox>
                                                <Checkbox checked={data.rights1} readOnly>
                                                    พื้นที่โครงการพัฒนาดอยตุงฯ
                                                </Checkbox>
                                                <Checkbox checked={data.rights2} readOnly>
                                                    พื้นที่ขยายผลในมูลนิธิฯ
                                                </Checkbox>
                                                <Checkbox checked={data.rights3} readOnly>
                                                    โรงเรียนบ้านห้วยไร่สามัคคี
                                                </Checkbox>
                                            </div>
                                        </div>

                                        {/* ข้อมูลทั่วไป */}
                                        <div>
                                            <div
                                                style={{
                                                    fontWeight: '700',
                                                    textDecoration: 'underline',
                                                    color: '#222',
                                                    marginTop: '1.5em',
                                                }}
                                            >
                                                ข้อมูลทั่วไป
                                            </div>
                                            <div>
                                                ชื่อ-สกุล: {data.first_name} {data.last_name} &nbsp;&nbsp;
                                                ชื่อเล่น: {data.nickname}
                                            </div>
                                            <div>
                                                วัน/เดือน/ปี เกิด: {this.formatDateOfBirth(data.date_of_birth)} &nbsp;&nbsp;
                                                อายุ: {calculateAge(data.date_of_birth)} ปี
                                            </div>
                                            <div>เบอร์โทร: {data.phone}</div>
                                            <div>
                                                ที่อยู่:{' '}
                                                {data.reg_province_id === 1 ? (
                                                    <>
                                                        บ้านเลขที่ {data.reg_house_number} หมู่ที่ {data.reg_village_no} หมู่บ้าน
                                                        {data.reg_village === 'other'
                                                            ? data.reg_village_name
                                                            : data.reg_village}{' '}
                                                        {data.reg_tambon} {data.reg_amphur} {data.reg_province}
                                                    </>
                                                ) : (
                                                    <>
                                                        บ้านเลขที่ {data.reg_house_number} หมู่ที่ {data.reg_village_no} หมู่บ้าน
                                                        {data.reg_village === 'other'
                                                            ? data.reg_village_name
                                                            : data.reg_village}{' '}
                                                        ต.{data.reg_tambon} อ.{data.reg_amphur} จ.{data.reg_province}
                                                    </>
                                                )}
                                            </div>
                                            <div>เลขบัตรประชาชน: {data.id_card_number}</div>
                                            <div>
                                                การศึกษาเดิม: {data.edu_level} &nbsp;&nbsp; โรงเรียน:{' '}
                                                {data.curr_institution} &nbsp;&nbsp; สายการเรียน: {data.curr_field}
                                            </div>
                                            <div>ผลการเรียน: {data.grades}</div>
                                        </div>

                                        {/* ข้อมูลการศึกษาต่อ */}
                                        <div>
                                            <div
                                                style={{
                                                    fontWeight: '700',
                                                    textDecoration: 'underline',
                                                    color: '#222',
                                                    marginTop: '1.5em',
                                                }}
                                            >
                                                ข้อมูลการศึกษาต่อ
                                            </div>
                                            <div>สถานศึกษา: {data.next_institution}</div>
                                            <div>สาขาที่ศึกษาต่อ: {data.next_field}</div>
                                        </div>

                                        {/* ข้อมูลการพิจารณาทุน */}
                                        <div>
                                            <div
                                                style={{
                                                    fontWeight: '700',
                                                    textDecoration: 'underline',
                                                    color: '#222',
                                                    marginTop: '1.5em',
                                                }}
                                            >
                                                ข้อมูลการพิจารณาทุน
                                            </div>
                                            <div style={{ marginTop: '0.5em', fontWeight: '700' }}>
                                                ส่วนที่ 1 ครอบครัวและรายได้
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                สภาพครอบครัว: {data.parent_status}
                                            </div>
                                            <div style={{ marginLeft: '2.4em' }}>
                                                ชื่อบิดา: {data.father_full_name} &nbsp;&nbsp; อาชีพ: {data.father_occupation}
                                            </div>
                                            <div style={{ marginLeft: '2.4em' }}>
                                                ชื่อมารดา: {data.mother_full_name} &nbsp;&nbsp; อาชีพ: {data.mother_occupation}
                                            </div>
                                            <div style={{ marginLeft: '2.4em' }}>
                                                จำนวนพี่น้อง: {data.total_siblings} คน
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                รายได้รวมต่อปี: {this.formatBaht(data.family_income_per_year)} บาท
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                ที่อยู่อาศัยในพื้นที่: {data.family_residence_rai} ไร่{' '}
                                                {data.family_residence_ngan} งาน {data.family_residence_wah} ตร.วา
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                ที่ทำกินในพื้นที่: {data.family_work_rai} ไร่{' '}
                                                {data.family_work_ngan} งาน {data.family_work_wah} ตร.วา
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                ที่อยู่อาศัยนอกพื้นที่: - ไร่ - งาน - ตร.วา
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                ที่ทำกินนอกพื้นที่: - ไร่ - งาน - ตร.วา
                                            </div>
                                        </div>

                                        {/* กิจกรรม */}
                                        <div>
                                            <div style={{ fontWeight: '700', marginTop: '1.5em' }}>
                                                ส่วนที่ 2 กิจกรรมที่เข้าร่วมระหว่างเรียน
                                            </div>
                                            <div style={{ marginLeft: '1.2em' }}>
                                                <div>
                                                    <b>กิจกรรมที่เคยเข้าร่วมกับมูลนิธิแม่ฟ้าหลวงฯ:</b> {data.doitung_activities}
                                                </div>
                                                <div>
                                                    <b>กิจกรรมที่เข้าร่วมกับโรงเรียน:</b> {data.school_activities}
                                                </div>
                                                <div>
                                                    <b>กิจกรรมอื่นๆ:</b> {data.other_activities}
                                                </div>
                                            </div>
                                        </div>

                                        {this.state.committee_groups === '2' &&
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: '700',
                                                        marginTop: '1.5em',
                                                        textDecoration: 'underline'
                                                    }}
                                                >
                                                    ข้อคิดเห็นของคณะกรรมการชุดที่ 1
                                                </div>

                                                <div
                                                    style={{
                                                        background: '#f2f2f2',
                                                        padding: '1em',
                                                        borderRadius: '8px',
                                                        marginTop: '0.5em'
                                                    }}
                                                >
                                                    <pre>{data.committee1_comment || '-'}</pre>
                                                </div>
                                            </div>
                                        }

                                    </Card.Body>
                                </Card>

                                <Text weight="bold" className="mb-2">
                                    เกณฑ์การพิจารณาคัดเลือกนักเรียนทุน (ตามการสัมภาษณ์)
                                </Text>

                                <div
                                    className="table-responsive"
                                    style={{
                                        borderRadius: '12px',
                                        overflowX: 'auto',
                                    }}
                                >
                                    <table
                                        className="table table-bordered table-hover align-middle mb-0"
                                        style={{ minWidth: '1200px' }}
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    style={{
                                                        width: 60,
                                                        verticalAlign: 'middle',
                                                        textAlign: 'center',
                                                        backgroundColor: 'rgb(138, 10, 10)',
                                                        color: '#fff',
                                                        fontWeight: 'normal',
                                                        height: '40px',
                                                        lineHeight: 0.9,
                                                    }}
                                                >
                                                    ลำดับ
                                                </th>
                                                <th
                                                    style={{
                                                        minWidth: 400,
                                                        maxWidth: 710,
                                                        verticalAlign: 'middle',
                                                        textAlign: 'center',
                                                        backgroundColor: 'rgb(138, 10, 10)',
                                                        color: '#fff',
                                                        fontWeight: 'normal',
                                                        height: '40px',
                                                        lineHeight: 0.9,
                                                    }}
                                                >
                                                    หัวข้อการให้คะแนน
                                                </th>
                                                <th
                                                    style={{
                                                        width: 80,
                                                        verticalAlign: 'middle',
                                                        textAlign: 'center',
                                                        backgroundColor: 'rgb(138, 10, 10)',
                                                        color: '#fff',
                                                        fontWeight: 'normal',
                                                        height: '40px',
                                                        lineHeight: 0.9,
                                                    }}
                                                >
                                                    น้ำหนัก
                                                </th>

                                                {[
                                                    ['ดีเยี่ยม', 5],
                                                    ['ดี', 4],
                                                    ['ปานกลาง', 3],
                                                    ['พอใช้', 2],
                                                    ['ต่ำกว่ามาตรฐาน', 1],
                                                ].map(([label, scoreValue]) => (
                                                    <th
                                                        key={scoreValue}
                                                        style={{
                                                            width: label === 'ต่ำกว่ามาตรฐาน' ? 120 : 100,
                                                            verticalAlign: 'middle',
                                                            textAlign: 'center',
                                                            backgroundColor: 'rgb(138, 10, 10)',
                                                            color: '#fff',
                                                            fontWeight: 'normal',
                                                            height: '40px',
                                                            lineHeight: 0.9,
                                                        }}
                                                    >
                                                        <div>
                                                            {label}
                                                            <br />
                                                            ({scoreValue})
                                                        </div>
                                                    </th>
                                                ))}

                                                <th
                                                    style={{
                                                        width: 100,
                                                        verticalAlign: 'middle',
                                                        textAlign: 'center',
                                                        backgroundColor: 'rgb(138, 10, 10)',
                                                        color: '#fff',
                                                        fontWeight: 'normal',
                                                        height: '40px',
                                                        lineHeight: 0.9,
                                                    }}
                                                >
                                                    รวม
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.scoringCriteriaList.map((rowData, rowIndex) => {
                                                const total = rowData.weight * (rowData.selectedScore || 0);
                                                return (
                                                    <tr
                                                        key={rowData.committeeId || rowIndex}
                                                        style={{
                                                            backgroundColor: '#fff', // ✅ สีพื้นหลังของ body เป็นสีขาว
                                                        }}
                                                    >
                                                        <td className="text-center" style={{ verticalAlign: 'top' }}>
                                                            {rowData.no}
                                                        </td>
                                                        <td
                                                            style={{
                                                                whiteSpace: 'pre-wrap',
                                                                wordBreak: 'break-word',
                                                                maxWidth: '700px',
                                                                verticalAlign: 'middle',
                                                            }}
                                                        >
                                                            {rowData.criteria}
                                                        </td>
                                                        <td className="text-center" style={{ verticalAlign: 'middle' }}>{rowData.weight}</td>

                                                        {[5, 4, 3, 2, 1].map((scoreValue) => (
                                                            <td key={scoreValue} style={{ verticalAlign: 'middle' }}>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                    }}
                                                                >
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={rowData.selectedScore === scoreValue}
                                                                        onChange={() =>
                                                                            this.handleScoreChange(rowData.committeeId, rowData.applicationId, scoreValue, mode, voteId, this.state.comment)
                                                                        }
                                                                        id={`checkbox-${rowData.committeeId}-${scoreValue}`}
                                                                    />
                                                                </div>
                                                            </td>
                                                        ))}

                                                        <td
                                                            className="text-end"
                                                            style={{
                                                                verticalAlign: 'middle',
                                                                width: 100, // ✅ ให้ตรงกับ header
                                                            }}
                                                        >
                                                            {total.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                        <tfoot>
                                            <tr style={{ backgroundColor: '#f1f1f1', fontWeight: 'bold' }}>
                                                <td colSpan={8} className="text-end" style={{ verticalAlign: 'middle' }}>
                                                    คะแนนรวม
                                                </td>
                                                <td
                                                    className="text-end"
                                                    style={{
                                                        verticalAlign: 'middle',
                                                        width: 100, // ✅ ให้ตรงกับช่องรวม
                                                    }}
                                                >
                                                    {this.state.scoringCriteriaList
                                                        .reduce((sum, item) => sum + item.weight * (item.selectedScore || 0), 0)
                                                        .toFixed(2)}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </Col>
                        </Row>

                        {this.state.committee_groups === '2' &&
                            <Row className='mt-3'>
                                <Col>
                                    <Text weight="bold" className="mb-2">ข้อสังเกต/ข้อคิดเห็นอื่นๆ </Text>
                                    <Input
                                        as="textarea"
                                        rows={4}
                                        placeholder={"กรุณาระบุข้อความ"}
                                        defaultValue={this.state.comment}
                                        onChange={e => this.setState({ comment: e })}
                                    />
                                </Col>
                            </Row>
                        }
                    </Modal.Body>

                    <Modal.Footer className="mt-2">
                        <Button
                            size="md"
                            appearance="primary"
                            startIcon={<i className="bi bi-floppy-fill"></i>}
                            onClick={() => this.onConfirm({ mode: 'update', applicationId: data.id, committeeId: this.state.committee_id })}
                        >
                            บันทึก
                        </Button>
                        <Button
                            size="md"
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        });
    };

    onConfirm = async ({ mode, applicationId, committeeId }) => {
        if (mode === 'update') {
            const list = this.state.scoringCriteriaList.filter(item => item.applicationId === applicationId);

            if (list.length === 0) {
                await Swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูลสำหรับผู้สมัครนี้',
                });
                return;
            }

            const incomplete = list.find(item => !item.selectedScore);

            if (incomplete) {
                await Swal.fire({
                    icon: 'warning',
                    title: 'กรุณาเลือกลงคะแนนให้ครบถ้วน',
                });
                return;
            }

            this.setState({ loading: true });

            try {
                const payload = {
                    year: this.state.year,
                    committee_id: committeeId,
                    application_id: applicationId,
                    total: parseFloat(
                        list.reduce((sum, item) => sum + item.weight * (item.selectedScore || 0), 0).toFixed(2)
                    ),
                    score: list.map(item => ({
                        criteria_id: item.committeeId,
                        score: item.selectedScore || 0,
                    })),
                    comment: this.state.comment,
                    status: true,
                };

                const response = await axios.post(`${process.env.REACT_APP_API}/voting`, payload);

                if (!(response.status === 201 && response.data?.message?.toLowerCase() === 'successfully')) {
                    throw new Error('Unexpected response');
                }

                await this.promisedSetState({ modal: null, loading: false });

                const result = await Swal.fire({
                    title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                    icon: "success",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                // ✅ หลัง SweetAlert แสดงเสร็จ
                if (result.isConfirmed || result.dismiss) {
                    this.onRenderContent({ mode: 'read' });
                }

            } catch (error) {
                console.error(error);
                await this.promisedSetState({ modal: null, loading: false });

                await Swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถบันทึกคะแนนได้ กรุณาลองใหม่',
                });
            }
        }
    };

    confirmVote = async ({ status, id }) => {
        if (status === 'close') {
            const result = await Swal.fire({
                title: 'ยืนยันการลงคะแนน',
                html: `<div style="color: red; font-size: 1.4rem; margin-bottom: 1rem;">
                    หากยืนยันการลงคะแนนแล้ว จะไม่สามารถแก้ไขคะแนนได้อีก <br/><b>คุณต้องการดำเนินการต่อหรือไม่?</b>
                  </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: '<div style="font-size: 1.425rem">ยืนยัน</div>',
                cancelButtonText: '<div style="font-size: 1.425rem">ยกเลิก</div>'
            });

            if (result.isConfirmed) {
                try {
                    // เรียก PATCH API เพื่อบันทึก
                    const response = await axios.patch(`${process.env.REACT_APP_API}/committee/confirm/${id}`);

                    // ตรวจสอบว่ามี message จาก server
                    if (response.data && response.data.message === 'Vote confirmed successfully') {
                        // แสดง Swal success
                        await Swal.fire({
                            title: 'การลงคะแนนของคุณได้ยืนยันเรียบร้อยแล้ว',
                            icon: 'success',
                            confirmButtonText: '<div style="font-size: 1.425rem">ตกลง</div>' // plain text
                        });

                        // เรียกฟังก์ชัน onRenderContent ทันที ไม่ต้องรอ confirm
                        this.onRenderContent({ mode: 'read' });
                    }

                } catch (error) {
                    // แสดง error
                    await Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        html: `<div style="color: red; font-size: 1.425rem">${error.response?.data?.error || error.message}</div>`,
                        icon: 'error',
                        confirmButtonText: '<div style="font-size: 1.425rem">ตกลง</div>' // plain text
                    });
                }
            }
        }
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(DetailPage);
